import React from 'react';

const Indicator = ({formIndex}) => {
    const totalSteps = 10;
    // formIndex commence à 1, donc currentStep = formIndex
    const currentStep = formIndex;
    
    const progressBar = {
        1:'w-[10%]',
        2:'w-[20%]',
        3:'w-[30%]',
        4:'w-[40%]',
        5:'w-[50%]',
        6:'w-[60%]',
        7:'w-[70%]',
        8:'w-[80%]',
        9:'w-[90%]',
        10:'w-[100%]'
    }
    
    return (
        <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="flex-1 min-w-0">
                <div className="mb-1.5">
                    <span className="text-sm font-medium text-gray-700">
                        Étape {currentStep} sur {totalSteps}
            </span>
                </div>
                <div className="h-2 w-full max-w-xs bg-gray-100 rounded-full overflow-hidden">
                    <div 
                        className={`${progressBar[formIndex] || 'w-[0%]'} bg-gradient-to-r from-yellow-400 to-yellow-500 h-full rounded-full transition-all duration-300 ease-out`}
                    />
                </div>
            </div>
        </div>
    );
};

export default Indicator;